
(() => {
  async function loadCartRecommendations(container) {
    if (container.dataset.loaded === 'true') return;

    container.dataset.loaded = 'true';

    try {
      const response = await fetch(container.dataset.url);

      if (!response.ok) {
        container.dataset.loaded = 'false';
        return;
      }

      const html = await response.text();
      const documentFromResponse = new DOMParser().parseFromString(html, 'text/html');
      const updatedContainer = documentFromResponse.querySelector(
        '.cart-drawer__recommendations-loader'
      );

      if (updatedContainer && updatedContainer.innerHTML.trim()) {
        container.innerHTML = updatedContainer.innerHTML;
      } else {
        container.remove();
      }
    } catch (error) {
      container.dataset.loaded = 'false';
      console.error('Unable to load cart recommendations:', error);
    }
  }

  function findCartRecommendations() {
    document
      .querySelectorAll('.cart-drawer__recommendations-loader[data-url]')
      .forEach(loadCartRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findCartRecommendations);
  } else {
    findCartRecommendations();
  }

  new MutationObserver(findCartRecommendations).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
